require('./_mdb-default');

import LazyLoad from 'lazyload';
import LocalStorage from '@js/modules/utils/localstorage';

import utils from '@js/modules/utils/utils';
import photoswipe from '@js/modules/utils/photoswipe';

import { preventDuplicateSubmit, preventDuplicateClick } from './utils/prevent_events';

import { EmptyCss } from './utils/check_css';

var notification_new_count: number = 0;
var notification_new_shown_ids: string = '';

function calcContentTop() {
    const headerEl: HTMLElement = document.querySelector('header.siteHeader, section.siteHeader');
    if (headerEl == null) return;
    if (headerEl.classList.contains('noHeaderMargin')) return;
    const navEl: HTMLElement = headerEl.querySelector('nav.fixed-top');
    if (navEl == null) return;

    var calcHeight;
    if (headerEl.classList.contains('fitHeaderMargin')) {
        calcHeight = navEl.getBoundingClientRect().height;
    } else {
        calcHeight = navEl.getBoundingClientRect().height + 16;
    }

    const target_id = 'header-nav-margin';
    var marginEl: HTMLElement = document.getElementById(target_id);
    if (marginEl == null) {
        marginEl = document.createElement('div');
        marginEl.id = target_id;
        headerEl.after(marginEl);
    }
    marginEl.style.marginTop = calcHeight + 'px';
}

function initAgreeCookie() {
    const tagDlg = $('#AgreeCookie');
    if (tagDlg.length == 0) return;

    const flg = LocalStorage.getItem('AgreeCookie');
    if (flg != null && flg == '1') return;

    const tagAgree = $('#BtnAgreeCookie');
    tagAgree.on('click', function (ev) {
        ev.preventDefault();
        LocalStorage.setItem('AgreeCookie', '1');
        tagDlg.css('display', 'none');
    });

    tagDlg.css('display', 'block');
}

function showNotification(event: Event) {
    const elmCount = document.getElementById('notification_count');

    const elmCollapse: HTMLDivElement = <HTMLDivElement>event.target;
    elmCollapse.removeEventListener('show.bs.collapse', showNotification);

    const attrId = elmCollapse.parentElement.attributes.getNamedItem('data-item-id');
    if (attrId) {
        notification_new_count--;

        const elmNew = document.getElementById('n-new-' + attrId.value);
        if (elmNew) {
            elmNew.remove();
        }

        if (elmCount) {
            if (notification_new_count > 0) {
                elmCount.innerHTML = notification_new_count.toString();
            } else {
                elmCount.remove();
            }
        }

        if (notification_new_shown_ids) {
            notification_new_shown_ids += ',' + attrId.value;
        } else {
            notification_new_shown_ids = attrId.value;
        }

        LocalStorage.setItem('ShownNotifications', notification_new_shown_ids);
    }
}

function initNotification() {
    const elmCount = document.getElementById('notification_count');
    if (elmCount == null) {
        return;
    }

    const shown_id_list: Array<string> = [];
    const shown_ids: string = LocalStorage.getItem('ShownNotifications');
    if (shown_ids) {
        shown_ids.split(',').forEach(id => {
            shown_id_list.push(id);
        });
    }

    const listItems = document.querySelectorAll('#notification_list .accordion-item');

    const new_shown_id_list: Array<string> = [];
    listItems.forEach(elmItem => {
        const attrId = elmItem.attributes.getNamedItem('data-item-id');
        if (attrId) {
            if (shown_id_list.includes(attrId.value)) {
                new_shown_id_list.push(attrId.value);
                const elmNew = document.getElementById('n-new-' + attrId.value);
                if (elmNew) {
                    elmNew.remove();
                }
            } else {
                notification_new_count++;
                const elmCollapse = document.getElementById('n-area-' + attrId.value);
                if (elmCollapse) {
                    elmCollapse.addEventListener('show.bs.collapse', showNotification);
                }
            }
        }
    });

    if (notification_new_count > 0) {
        elmCount.innerHTML = notification_new_count.toString();
    }

    notification_new_shown_ids = new_shown_id_list.join(',');
    if (shown_ids == null || shown_ids != notification_new_shown_ids) {
        LocalStorage.setItem('ShownNotifications', notification_new_shown_ids);
    }
}

function hookScrollFadeIn() {
    var targets = $('.scroll-fadein');
    if (!targets) {
        return;
    }

    window.addEventListener('scroll', function () {
        if ($(this).scrollTop() > 100) {
            targets.fadeIn();
        } else {
            targets.fadeOut();
        }
    });
}

function hookPageTop() {
    var pagetop = $('.pagetop');
    if (!pagetop) {
        return;
    }

    pagetop.on('click', function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
    });
}

calcContentTop();

hookScrollFadeIn();
hookPageTop();

initAgreeCookie();
utils.initUserMenu();

photoswipe.init();

try {
    const images = document.querySelectorAll('.lazyload');
    new LazyLoad(images);
} catch (e) {}

initNotification();

(window as any).preventDuplicateSubmit = preventDuplicateSubmit;
(window as any).preventDuplicateClick = preventDuplicateClick;

try {
    const url = new URL(location.href);
    if (url.searchParams.get('check') && url.searchParams.get('check') == 'css') {
        EmptyCss();
    }
} catch (e) {}

// 一部ファンサイト用
require('./mdb-custom/migration_mdb4');
